import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchBatterystatus } from './batterystatusAPI'; // Assume this API function accepts filters as a parameter.
import { act } from 'react';

const initialState = {
  data: {},
  status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};


// Async thunk to fetch data with filters
export const fetchBatterystatusDataWithFilters = createAsyncThunk(
  'batterystatus/fetchBatterystatusDataWithFilters',
  async ({ filter = {}, options = {} }) => {
    const response = await fetchBatterystatus({ filter, options }); // Pass filters to the API    
    return response.data; // Assuming the API response contains a `data` field
  }
);

export const BatterystatusSlice = createSlice({
  name: 'batterystatus',
  initialState,
  reducers: {}, // No need for additional reducers in this simplified version
  extraReducers: (builder) => {
    builder
      .addCase(fetchBatterystatusDataWithFilters.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchBatterystatusDataWithFilters.fulfilled, (state, action) => {
        state.status = 'succeeded';
        // console.log(action.payload)
        // state.data = action.payload;
        // console.log(" battery state data", action.payload);
        state.data[action.payload?.vin || 0] = action.payload || { less_than_10: 0, between_10_and_80: 0, greater_than_80: 0 }; // Store the fetched data
      })
      .addCase(fetchBatterystatusDataWithFilters.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message; // Store error message
      });
  },
});

// Selector to access the data and status
export const selectBatterystatusData = (state) => state.batterystatus.data;
export const selectBatterystatusStatus = (state) => state.batterystatus.status;
export const selectBatterystatusError = (state) => state.batterystatus.error;

export default BatterystatusSlice.reducer;
